export default "__VITE_ASSET__W69KRIKE__"